<template>
    <div>
      <div class="bgc_white">
        <NavbarHeader activeName="about"></NavbarHeader>
        <div v-if="bannerList.length>0" style="background-color: #F5F5F5;">
          <swiperList :bannerList="bannerList"></swiperList>
        </div>
        <div class="gflex flexcolumn recommend_section">
          <div class="menu_text2">
            <headerTitle englishText="COMPANY PROFILE"
            positiveTitle="公司简介" subheading="哥弟商元贸易有限公司"></headerTitle>
          </div>
          <div class="about_text">
            哥弟品牌，源自中国台湾，始于公元1977 年，本着将心比心，相辅相成的团队观，秉持物有所值，物超所值的诚信经营理念。期望打造出一个不断创造工作机会，回馈社会，有信望爱的企业。
            <br/><br/>
            哥弟人，随时随地深呼吸，塑造健康的身心，同心协力，同舟共济，努力积累能力，能力持续努力。哥弟人孜孜以求的不仅仅是时装品味，更是生活与人生的品味，共同谆谆传递着真、善、美。
            <br/><br/>
            哥弟商元，创立于2020年，由哥弟集团官方授权的生活家居好物分享平台。将持续遵循物有所值、物超所值的经营理念，提供家居、运动、母婴、养生、美容等多元化精选商品。
            <br/><br/>
            <p class="about_four">哥弟四海，四海哥弟，“将”心选之。</p><br/>
          </div>
        </div>
        <div class="about_brief" v-if="windowWidth>480">
          <img class="about_bgimg1" :src="bathUrl+'f0ff20a9-1033-424d-ae25-2201cdae8f74.png'" />
          <el-image class="about_bgimg2" :src="bathUrl+'f0ff20a9-1033-424d-ae25-2201cdae8f74.png'" fit="cover"></el-image>
          <div class="brief_smallimgout flex">
            <el-image class="brief_smallimginner" :src="bathUrl+'3b5fe220-f00e-458c-bec6-fee04434d71a.png'" fit="cover"></el-image>
            <div class="brief_text">
              <p>哥弟四海，四海哥弟，“将”心选之。</p>
              <p class="brief_font2">——哥弟商元贸易有限公司</p>
            </div>
          </div>
        </div>
        <div v-else>
          <img class="about_bgimg1" :src="require('../../assets/image/aboutus_img.png')" />
        </div>
        <div class="gflex flexcolumn recommend_section">
          <div class="menu_text3">
            <headerTitle englishText="TRADEMARK"
            positiveTitle="商标授权" subheading="诚信经营  用心服务"></headerTitle>
          </div>
          <aboutBrief v-if="companyAuthInfo.length>0" :briefList="companyAuthInfo"></aboutBrief>
          <div class="menu_text3">
            <headerTitle englishText="OWNERSHIP STRUCTURE"
            positiveTitle="哥弟股权结构" subheading="诚信经营  用心服务"></headerTitle>
          </div>
          <aboutBrief v-if="companyGirlDearInfo.length>0" :briefList="companyGirlDearInfo"></aboutBrief>
          <div class="menu_text3">
            <headerTitle englishText="OWNERSHIP STRUCTURE"
            positiveTitle="哥弟商元股权结构" subheading="诚信经营  用心服务"></headerTitle>
          </div>
          <aboutBrief v-if="companyShangYuanInfo.length>0" :briefList="companyShangYuanInfo"></aboutBrief>
        </div>
        <div class="menu_text4">
          <headerTitle englishText="BUSINESS COOPERATION"
          positiveTitle="商务合作" subheading="期待与您进行多样化的商业合作模式"></headerTitle>
        </div>
        <div class="business_section">
          <div class="business_left">
            <el-image class="business_img" :src="require('../../assets/image/about_cooperation.png')" fit="cover"></el-image>
          </div>
          <div class="business_wrap">
            <div class="business_innerwrap">
              <img class="business_logo1" :src="require('../../assets/image/aboutus_logo.png')" />
              <img class="business_logo2" :src="require('../../assets/image/aboutus_logo1.png')" />

              <div class="business_content">
                哥弟商元隶属于哥弟集团旗下，作为一个全新的电商平台，哥弟商元将<br/>
                持续秉持着将心比心，相辅相成的团队观；<br/><br/>

                <p class="business_font1">物有所值，物超所值的经营理念，竭诚为大众提供集家居服饰家居家纺</p>
                个人护理、家清卫浴、健康养生等一系列，多元化的精品。
              </div>
              <div class="gflex business_wrapcode">
                <img class="business_code" :src="require('../../assets/image/aboutus_code.png')" />
                <div class="business_scantext">扫码登记</div>
              </div>
              <div class="business_sign" @click="showScancode=true">立即登记</div>
            </div>
          </div>
        </div>
        <footerBar></footerBar>
      </div>
      <!-- <el-dialog title="" width="300px" :visible.sync="showScancode"> -->
      <van-popup v-model="showScancode" closeable position="center"
        :style="{ borderRadius: '10px' }">
        <div class="scancode_wrap flexcenter flexcolumn">
          <div class="codeimg_inner">
            <img class="codeimg" :src="require('../../assets/image/aboutus_code.png')" />
          </div>
          <p class="codetext">扫码登记合作意向</p>
        </div>
      </van-popup>

    </div>
</template>
<script>
	import { basebannerListapi, companyinfobaseapi
	} from "@/api/apilist/commonApi";
  import headerTitle from "@/components/assembly/headerTitle.vue";
  import aboutBrief from "@/components/assembly/aboutBrief.vue";
  import swiperList from "@/components/assembly/swiperList.vue";
  import footerBar from "@/components/footerBar/footerBar.vue";
  import NavbarHeader from "@/components/NavbarHeader/NavbarHeader.vue";
  export default {
      components: {
        NavbarHeader, footerBar, swiperList, aboutBrief, headerTitle
      },
      data() {
        return {
          bathUrl: 'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/',
          bannerList: [],
          companyAuthInfo: [],
		  companyGirlDearInfo: [],
		  companyShangYuanInfo: [],
          cateCurrent: 0,
          cateLeft: 0,
          cateTotalwidth: 0,
          showarrowLeft: false,
          showarrowRight: true,
          windowWidth: 1200,
          showScancode: false,
        };
      },

      created() {
		this.getbasebannerList();
		this.getcompanyinfobase();
      },
      mounted(){
        this.windowWidth = document.documentElement.clientWidth;
        window.addEventListener('resize', () => { //监听浏览器窗口大小改变
                //浏览器变化执行动作
          this.windowWidth = window.innerWidth
        });
      },
      methods:{
		getcompanyinfobase() {
	    	companyinfobaseapi().then(res=>{
	    		this.companyAuthInfo = res.data.companyAuthInfo;
				this.companyGirlDearInfo = res.data.companyGirlDearInfo;
				this.companyShangYuanInfo = res.data.companyShangYuanInfo;
	    	})
		},
		getbasebannerList() {
		  	basebannerListapi({ bannerType: 4 }).then(res=>{
		  		this.bannerList = res.data;
		  	})
		},
        fnPrev(){
          if(this.cateLeft>= -264){
            this.cateLeft = 0;
            this.cateTotalwidth = 0;
          }else{
            this.cateLeft = this.cateLeft + 264;
          }
        },
        fnNext(){
          let mylength = this.categrayList.length - 4;
          if(this.cateTotalwidth<mylength){
            this.cateTotalwidth +=1;
            this.cateLeft = this.cateLeft-264;
          }
        },
      }
  }
</script>

<style scoped lang="less">
  @media screen and (max-width: 480px){
    .recommend_section{width: 100%;font-size: 14px;padding: 0 15px;}
    .menu_text2{margin: 52px auto 15px;}
    .menu_text3{margin: 41px auto 20px;}
    .menu_text4{margin: 41px auto 20px;}
    .about_text{font-size: 16px;}
    .about_bgimg1{ width: 100%; }
    .business_section{
      background-color: #fff;
      padding-bottom: 50px;
      .business_img{display: block;}
      .business_wrap{
        padding: 15px;
        .business_innerwrap{
          .gflex{display: none;}
        }
        .business_logo1{display: none;}
        .business_logo2{
          width: 158px;
          // height: 35px;
          margin-bottom: 15px;
        }
        .business_sign{
          width: 100%;
          height: 40px;
          background-color: #D9BF81;
          color: #fff;
          font-weight: bold;
          font-size: 14px;
          border-radius: 5px;
          margin-top: 20px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
      }
    }
    .scancode_wrap{
      width: 300px;
      height: 320px;
      border-radius: 10px;
      text-align: center;
      .codeimg_inner{
        padding: 10px;
        border-radius: 50%;
        width: 195px;
        height: 195px;
        margin: 0 auto;
        background-color: #fff;
        overflow: hidden;
      }
      .codeimg{
        width: 180px;
        height: 180px;
      }
      .codetext{
        font-size: 18px;
        margin-top: 22px;
      }
    }
    ::v-deep .el-dialog{background-color: #F2F2F2;border-radius: 10px;}
	.business_content{font-size: 16px;}
  }
  @media screen and (min-width: 1451px){
      .business_content{
        font-size: 18px;
      }
      .business_scantext{
        font-size: 20px;
      }
      .business_code{
        width: 150px;
        height: 150px;
        margin-right: 20px;
        border-radius: 50%;
      }
      .recommend_section{
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
      }
      .menu_text2{margin: 111px auto 25px;}
      .menu_text3{margin: 91px auto 40px;}
      .menu_text4{margin: 91px auto 50px;}
      .about_text{font-size: 18px;}
      .about_four{display: none;}
      .about_bgimg1{ width: 100%;height: 500px;opacity: 0; }
      .business_section{
        background-color: #F2F2F2;
        margin-bottom: 100px;
        height: auto;
        align-items: stretch;
        min-width: 1200px;
        display: flex;
        .business_left{flex: 1;}
        .business_img{display: block;}
        .business_wrap{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .business_innerwrap{
            padding-left: 42px;
            height: 73%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .business_logo1{
            width: 253px;
          }
          .business_logo2{display: none;}
          .business_sign{display: none;}
        }
      }
  }
  @media screen and(min-width: 481px) and (max-width: 1450px){
      .business_content{
        font-size: 16px;margin-top: 30px;
      }
      .business_font1{margin-top: 20px;}
      .business_scantext{
        font-size: 18px;
        font-weight: bold;
      }
      .business_wrapcode{margin-top: 30px;}
      .business_code{
        width: 110px;
        height: 110px;
        margin-right: 20px;
        border-radius: 50%;
      }
      .recommend_section{
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
      }
      .menu_text2{margin: 111px auto 25px;}
      .menu_text3{margin: 91px auto 40px;}
      .menu_text4{margin: 91px auto 50px;}
      .about_text{font-size: 18px;}
      .about_four{display: none;}
      .about_bgimg1{ width: 100%;height: 500px;opacity: 0; }
      .business_section{
        background-color: #F2F2F2;
        margin-bottom: 100px;
        height: auto;
        align-items: stretch;
        min-width: 1200px;
        display: flex;
        .business_left{flex: 1;}
        .business_img{display: block;}
        .business_wrap{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .business_innerwrap{
            padding-left: 42px;
            height: 345px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .business_logo1{
            width: 253px;
          }
          .business_logo2{
            display: none;
          }
          .business_sign{display: none;}
        }
      }
  }
  .business_scantext{
    font-weight: bold;
  }
  .about_brief{
    width: 100%;
    height: 600px;
    position: relative;
    .about_bgimg2{
      width: 100%;
      height: 500px;
      position: absolute;
      top: 100px;
      left: 0;
      z-index: 2;
      filter: blur(4px);
    }
    .brief_smallimgout{
      width: 1200px;
      height: 500px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 3;
      margin: 0 auto;
      .brief_smallimginner{
        width: 550px;
        height: 500px;
        border-radius: 10px;
      }
      .brief_text{
        font-weight: bold;
        font-size: 24px;
        padding-top: 290px;
        padding-left: 73px;
        .brief_font2{
          margin-left: 246px;
          margin-top: 10px;
        }
      }
    }
  }
  .recommend_section{
    background-color: #fff;
  }


</style>
